module.exports = __webpack_public_path__ + "static/media/wth-merch.5cbec7d8.png";